<template>
  <section>
    <div class="card pb-3">
      <div class="row">
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center mb-lg-0 mb-3 text-right"
        >
          <div class="row">
            <div
              class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 align-self-center"
            >
              <div class="col-filter mr-2 no-mov">
                <WSelect
                  placeholder="Destinations"
                  v-model="destinationFilter"
                  id="filterDestinations"
                  name="filterDestinations"
                  filterable
                  indexTab="1"
                  label="Destinations"
                  class="select-filter mb-0"
                  clearable
                  @change="selectDestination"
                >
                  <el-option
                    v-for="(destination, index) in destinationsOptions"
                    :value="destination.slug"
                    :label="`${destination.city} - ${destination.country.name}`"
                    :key="index"
                  >
                    <span class="hide-data-inline coin-left">{{
                      destination.city
                    }}</span>
                    <span class="hide-data-inline coin-right">{{
                      destination.country.name
                    }}</span>
                  </el-option>
                </WSelect>
              </div>
            </div>
            <div
              class="col-xl-7 col-lg-7 col-md-7 col-sm-12 col-12 ml-md-auto ml-0 align-self-center mt-3 mt-md-0 text-right"
            >
              <div
                class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-9 d-inline-block"
              >
                <base-dropdown
                  menu-on-right
                  class="dropfilter"
                  tag="li"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral m-0 dropnocaret"
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button"
                    ><i class="flaticon-calendar mr-1"></i> {{ filtersDate }}
                  </base-button>

                  <div class="row">
                    <div class="col-8" v-on:click.stop.prevent>
                      <base-input label="" disabled="disabled">
                        <flat-picker
                          slot-scope="{ focus, blur }"
                          @on-open="focus"
                          @on-close="blur"
                          :config="{
                            altFormat: 'd-M-Y',
                            altInput: true,
                            minDate: 'year',
                            dateFormat: 'Y-m-d',
                            allowInput: true,
                            inline: true,
                            mode: 'range'
                          }"
                          class="input-custom"
                          v-model="filters.date"
                          id="date"
                          name="date"
                          placeholder="Date"
                          tabindex="4"
                        ></flat-picker>
                      </base-input>
                    </div>
                    <div class="col-4">
                      <base-button
                        type="outline-neutral"
                        class="min-button btn-block"
                        @click="filterByDate(today)"
                      >
                        Today
                      </base-button>
                      <base-button
                        type="outline-neutral"
                        class="min-button btn-block"
                        @click="filterByDate(thisWeek)"
                      >
                        This Week
                      </base-button>
                      <base-button
                        type="outline-neutral"
                        class="min-button btn-block"
                        @click="filterByDate(lastWeek)"
                      >
                        Last Week
                      </base-button>
                      <base-button
                        type="outline-neutral"
                        class="min-button btn-block"
                        @click="filterByDate(thisMonth)"
                      >
                        This month
                      </base-button>
                      <base-button
                        type="outline-neutral"
                        class="min-button btn-block"
                        @click="filterByDate(lastMonth)"
                      >
                        Last month
                      </base-button>
                      <base-button
                        type="outline-neutral"
                        class="min-button btn-block"
                        @click="filterByDate(thisYear)"
                      >
                        This Year
                      </base-button>
                      <base-button
                        type="primary"
                        class="min-button btn-block"
                        @click="filterByDate(filters.date)"
                      >
                        Apply
                      </base-button>
                    </div>
                  </div>
                </base-dropdown>
              </div>

              <base-button
                type="outline-neutral"
                class="min-button mb-0 mt-3 mt-sm-0"
                @click="download([])"
              >
                <i class="flaticon-downloading-files"></i>
                Reports
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="row justify-content-center">
        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 box-flex">
          <SimpleCardMetrics
            :title="`${statsCardPrimary.reservations.label}`"
            :percent="`${statsCardPrimary.reservations.percent}`"
            :sub-title="`${statsCardPrimary.reservations.count}`"
            icon="flaticon-contact-list"
            :condition="`${statsCardPrimary.reservations.condition}`"
          >
          </SimpleCardMetrics>
        </div>

        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 box-flex">
          <SimpleCardMetrics
            :title="`${statsCardPrimary.cancellations.label}`"
            :percent="`${statsCardPrimary.cancellations.percent}`"
            :sub-title="`${statsCardPrimary.cancellations.count}`"
            icon="flaticon-traffic-signal"
            :condition="`${statsCardPrimary.cancellations.condition}`"
          >
          </SimpleCardMetrics>
        </div>

        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 box-flex">
          <SimpleCardMetrics
            :title="`${statsCardPrimary.sales.label}`"
            :percent="`${statsCardPrimary.sales.percent}`"
            :sub-title="`${statsCardPrimary.sales.count}`"
            icon="flaticon-team"
            :condition="`${statsCardPrimary.sales.condition}`"
          >
          </SimpleCardMetrics>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 box-flex">
          <SimpleCardMetrics
            :title="`${statsCardPrimary.pay.label}`"
            :percent="`${statsCardPrimary.pay.percent}`"
            :sub-title="`${statsCardPrimary.pay.count}`"
            icon="flaticon-money-back-guarantee"
            :condition="`${statsCardPrimary.pay.condition}`"
          >
          </SimpleCardMetrics>
        </div>
      </div>
    </div>
    <div class="card">
      <h2 class="subtitle">Reservations</h2>
      <div class="forms mb-5">
        <div class="row">
          <div
            class="col-xl-5 col-lg-4 col-md-6 col-sm-6 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model.trim="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-7 col-lg-8 col-md-6 col-sm-6 col-12 alinmov2 align-self-center"
          >
            <div>
              <div class="box-buttons">
                <base-button
                  type="outline-neutral"
                  class="min-button"
                  v-if="activeFilter"
                  @click="resetSearchFilter()"
                >
                  <i class="flaticon-eraser"></i>Reset Search
                </base-button>
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-rec"></i>
                    <strong>Status</strong>
                  </base-button>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('SBC')"
                  >
                    <i class="flaticon-remove text-cancelled"></i> Cancelled
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('JF')"
                  >
                    <i class="flaticon-check text-completed"></i> Completed
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('SC')"
                  >
                    <i class="flaticon-bold-check-3 text-confirmed"></i>
                    Confirmed
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('BI')"
                  >
                    <i class="flaticon-time-left text-draft"></i> Draft
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('NW')"
                  >
                    <i class="flaticon-add text-new"></i> New
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('BI')"
                  >
                    <i class="flaticon-no-group text-no-show"></i> No Show
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('SRB')"
                  >
                    <i class="flaticon-warning-1 text-rejected"></i>
                    Rejected
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('PNDG')"
                  >
                    <i class="flaticon-wall-clock-1 text-pending"></i>
                    Pending
                  </div>
                </base-dropdown>
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-invoice"></i>
                    <strong>Payment</strong>
                  </base-button>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByStatusPayment('paid')"
                  >
                    <i class="flaticon-bold-check-3 text-success"></i> Paid
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByStatusPayment('unpaid')"
                  >
                    <i class="flaticon-wall-clock-1 text-danger"></i> Unpaid
                  </div>
                </base-dropdown>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2"
          >
            <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
              <b-form-radio-group
                id="radio-group-2"
                v-model.trim="filterStatus"
                :aria-describedby="ariaDescribedby"
                name="radio-sub-component"
                button-variant="type-tab"
                buttons
                @change="filteredTab"
                class="buttons-rows"
              >
                <b-form-radio value="all">All</b-form-radio>
                <b-form-radio value="NW"
                  >New
                  <badge
                    type="danger"
                    class="square"
                    v-if="newBookingsCount > 0"
                    >{{ newBookingsCount }}</badge
                  ></b-form-radio
                >

                <b-form-radio value="SRB"
                  >Rejected
                  <badge
                    type="danger"
                    class="square"
                    v-if="rejectedBookingsCount > 0"
                    >{{ rejectedBookingsCount }}</badge
                  ></b-form-radio
                >
                <b-form-radio value="unpaid"
                  >Unpaid
                  <badge
                    type="danger"
                    class="square"
                    v-if="upcomingBookingsCount > 0"
                    >{{ upcomingBookingsCount }}</badge
                  >
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div
            class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 text-right"
          >
            <div
              class="col-xl-7 col-lg-12 col-md-6 ml-auto d-inline-block mb-xl-0 mb-1"
            >
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class="mb-0"
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    @change="applySortBy"
                    :aria-describedby="ariaDescribedby"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-downloading-files mr-0"></i>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="
                      download(selectedRows.map(item => item.reservation))
                    "
                    v-if="selectedRows.length > 0"
                  >
                    Selected Records
                  </div>
                  <div class="dropdown-item" @click="download()">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>
          </div>
        </div>

        <pagination-block
          :pageCount="responseReservations.pages"
          :total="responseReservations.count"
          :limit="limit"
          v-model="currentPage"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          @changeLimit="changeLimit"
          position="bottom"
        ></pagination-block>

        <b-table
          hover
          :items="reservations"
          :fields="fields"
          :sort-by.sync="sortBySync"
          :sort-desc.sync="sortDescSync"
          selectable
          @row-selected="onRowSelected"
          select-mode="multi"
          ref="selectableTable"
          sort-icon-left
          show-empty
          empty-filtered-text="There are no records matching your request"
          empty-text="There are no records to show"
          :tbody-transition-props="transProps"
          :stacked="cardview"
          :table-class="getTableClass(reservations)"
          responsive
          sticky-header
        >
          <template #head()="{ label, field: { key } }">
            <span v-if="key === 'selected'">
              <span
                @click="clearSelected"
                v-if="selectedRows.length == reservations.length"
                class="check-table selected"
              ></span>

              <span @click="selectAllRows" v-else class="check-table"></span>
            </span>
            <span v-else>{{ label }}</span>
          </template>
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true" class="check-table selected"></span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true" class="check-table"></span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>

          <template #thead-top="data">
            <draggable
              tag="b-tr"
              v-model="fields"
              @change="changDraggable"
              draggable=".dragg"
              sortable="true"
              :sort="true"
            >
              <b-th
                v-for="(field, index) in fields"
                :key="index"
                class="draggable text-center"
                :class="[
                  {
                    'no-drag': !field.settings.drag,
                    dragg: field.settings.drag,
                    'b-table-sort-icon-left': field.sortable
                  }
                ]"
                style="padding: 0px 10px 10px 10px !important"
                :aria-sort="sortBySync"
                :width="field.width"
              >
                <span class="drag-drop" v-if="field.settings.drag"> </span>
              </b-th>
            </draggable>
          </template>

          <template #cell(booking_number)="data">
            <ReservationBookingNumber
              :reservation="data.item.reservation"
              :reservationClass="data.item.class"
            />
          </template>
          <template #cell(typeTransfer)="data">
            <span>{{ getBookingType(data.item.reservation.type) }} </span>
          </template>

          <template #cell(from)="data">
            <span class="multiline-3">{{ data.item.reservation.from }} </span>
          </template>

          <template #cell(to)="data">
            <span class="multiline-3">{{ data.item.reservation.to }} </span>
          </template>

          <template #cell(pickup_date)="data">
            <span>{{
              getFormatDate(data.item.reservation.pickup_date, formatD)
            }}</span>
            <span class="d-block">{{
              getFormatTime(data.item.reservation.pickup_time, formatT)
            }}</span>
          </template>

          <template #cell(passengersCount)="data">
            <span>{{ data.item.reservation.passengersCount }} </span>
          </template>

          <template #cell(flightNumber)="data">
            <div v-if="data.item.reservation.type != 'journey'">
              <span class="role-table">{{
                getLabelTransport(data.item.reservation.type)
              }}</span>
              <span
                class="d-block hide-data"
                :class="{
                  uppercase: getTransportReference(data.item.reservation)
                }"
              >
                {{
                  getTransportReference(data.item.reservation) || "Not included"
                }}</span
              >
            </div>

            <div v-else>
              <span>-</span>
            </div>
          </template>
          <template #cell(customer)="data">
            <ShowAgent
              v-if="data.item.reservation.agent"
              :agent="data.item.reservation.agent"
              :customerId="
                data.item.reservation.customer
                  ? data.item.reservation.customer._id
                  : null
              "
            />
            <ShowCustomer v-else :customer="data.item.reservation.customer" />
          </template>

          <template #cell(passenger)="data">
            <span class="text-capitalize">
              {{
                getPassenger(data.item.passengers, data.item.passengersCount)
              }}
            </span>
          </template>

          <template #cell(supplier)="data">
            <span class="role-table" v-if="data.item.reservation.branch">{{
              data.item.reservation.branch.name
            }}</span>
            <a
              v-if="data.item.reservation.supplier !== null"
              class="text-capitalize hide-data"
              :href="`/suppliers/${data.item.reservation.supplier._id}`"
              target="_blank"
              >{{ data.item.reservation.supplier.businessDetails.name }}</a
            >
          </template>

          <template #cell(driver)="data">
            <span class="text-capitalize" v-if="data.item.driver">{{
              data.item.driver
            }}</span>
            <span class="text-capitalize text-danger" v-else>Unassigned</span>
          </template>

          <template #cell(status)="data">
            <ReservationStatusBadge
              :item-class="data.item.class"
              :reservation="data.item.reservation"
            />
          </template>

          <template #cell(reservation_reference)="data">
            <span>{{ data.item.reservation.booking_reference }} </span>
          </template>

          <template #cell(quotedPrice)="data">
            <span :class="data.item.quotedPrice < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.quotedPrice }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(netPrice)="data">
            <span :class="data.item.netPrice < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.netPrice }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(grossPrice)="data">
            <span :class="data.item.grossPrice < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.grossPrice }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(netProfit)="data">
            <span :class="data.item.netProfit < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.netProfit }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(totalCharge)="data">
            <span :class="data.item.totalCharge < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.totalCharge }}
              {{ data.item.currency.code }}</span
            >
          </template>
          <template #cell(totalExtras)="data">
            <span :class="data.item.totalExtras < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.totalExtras }}
              {{ data.item.currency.code }}</span
            >
          </template>
          <template #cell(totalDiscounts)="data">
            <span :class="data.item.totalDiscounts < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.totalDiscounts }}
              {{ data.item.currency.code }}</span
            >
          </template>
          <template #cell(commission)="data">
            <span :class="data.item.commission < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.commission }}
              {{ data.item.currency.code }}</span
            >
          </template>
          <template #cell(payment)="data">
            <PaymentStatus
              :paymentStatus="data.item.reservation.payment_status"
              :paymentMethod="data.item.reservation.payment_method"
              :paymentLinkStatus="data.item.reservation.paymentLink.status"
              :paymentLink="data.item.reservation.paymentLink.url"
            />
          </template>
          <template #cell(invoicen)="data">
            <span>{{ data.item.reservation.invoice_number }} </span>
          </template>

          <template #cell(paymentreference)="data">
            <span>{{ data.item.reservation.payment_reference }} </span>
          </template>
          <template #cell(deal_number)="data">
            <span>{{ data.item.reservation.deal_number }} </span>
          </template>

          <template #cell(actions)="data">
            <div class="action-column">
              <div class="button-action mr-2">
                <el-tooltip
                  content="History"
                  placement="bottom"
                  class="d-inline-flex"
                >
                  <span
                    class="icon-action text-blue"
                    @click.stop="
                      openReservationHistory(
                        data.item.reservation._id,
                        data.item.reservation.booking_number
                      )
                    "
                  >
                    <i class="flaticon-wall-clock-1"> </i>
                  </span>
                </el-tooltip>
              </div>
              <ReservationRowActions
                :record="data.item.reservation"
                :item-class="data.item.class"
                :direction="getDirection(reservations, data.index)"
                :can-user-change-status="canUserChangeStatus"
                :can-user-mark-booking-as-paid="canUserMarkBookingAsPaid"
                :can-user-create="canUserCreate"
                :can-user-delete="canUserDelete"
                @updated="refreshReservations"
              />
            </div>
          </template>
        </b-table>
        <pagination-block
          :pageCount="responseReservations.pages"
          :total="responseReservations.count"
          v-model="currentPage"
          :limit="limit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          @changeLimit="changeLimit"
          position="bottom"
        ></pagination-block>
      </div>
      <ReservationHistory
        :show="showReservationHistory"
        :tempReservationId="tempReservationId"
        :bookingNumber="tempBookingNumber"
        @close="closeReservationHistoryModal"
      />
    </div>
  </section>
</template>

<script>
import moment from "moment-timezone";
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  ExportAPI,
  ReservationsAPI,
  SettingsAPI,
  OperatorsAPI,
  DestinationsAPI
} from "../../../core/api";
import { DropdownPlugin, TablePlugin } from "bootstrap-vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { DropdownMenu, DropdownItem, Dropdown, MessageBox } from "element-ui";
import WSelect from "@/components/Select";
import ReservationHistory from "../../reservations/components/ReservationHistory.vue";
import PaymentStatus from "../../reservations/components/PaymentStatus";
import ReservationBookingNumber from "@/components/ReservationBookingNumber";
import ReservationStatusBadge from "@/components/ReservationStatusBadge";
import ReservationRowActions from "@/components/ReservationRowActions";
import ShowCustomer from "../../../components/clients/ShowCustomer.vue";
import ShowAgent from "../../../components/clients/ShowAgent.vue";
import lodash from "lodash";
import draggable from "vuedraggable";
import SimpleCardMetrics from "rhomtrip_assets/src/components/Cards/SimpleCardMetrics";
import {
  calculateHoursDifference,
  canCancelBooking,
  cancelBooking,
  canCompleteBooking,
  canConfirmBooking,
  canDownloadQuote,
  canDownloadVoucher,
  canMarkBookingAsNoShow,
  canMarkBookingAsPaid,
  canResendBookingEmail,
  completeBooking,
  confirmBooking,
  deleteBooking,
  duplicateBooking,
  hasBookingsWithPaymentLink,
  hasCanceledBookings,
  hasDraftBookings,
  hasExpiredBookings,
  hasPaidBookings,
  markReservationsAsPaid,
  noShowBooking,
  resendNotifications,
  sendPaymentLink,
  getLabelTransport,
  getTransportReference,
  resolveRefundEligibility
} from "../../../helpers/reservation.helpers";
import { mapReservationsForTable } from "../../../helpers/reservation-table.helpers";

import { isPartner, isUserAuthorized, setSigOut } from "../../../helpers/commons.helpers";
import { RESERVATION_TABLE_DEFAULTS } from "../../../core/constants";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "ReservationBySupplierId",
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [MessageBox.name]: MessageBox,
    DropdownPlugin,
    TablePlugin,
    WSelect: WSelect,
    flatPicker,
    ReservationHistory: ReservationHistory,
    PaymentStatus: PaymentStatus,
    ReservationBookingNumber,
    ReservationStatusBadge,
    ReservationRowActions,
    ShowCustomer: ShowCustomer,
    ShowAgent: ShowAgent,
    draggable,
    SimpleCardMetrics
  },
  props: {
    supplierId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      limit: 0,
      currentPage: 1,
      selectedRows: [],
      simpleSearch: "",
      filters: {
        date: `${moment()
          .startOf("month")
          .format("YYYY-MM-DD")} to ${moment()
          .endOf("month")
          .format("YYYY-MM-DD")}`,
        supplier: "",
        branch: []
      },
      filtersDate: `${moment()
        .startOf("month")
        .format("YYYY-MM-DD")} to ${moment()
        .endOf("month")
        .format("YYYY-MM-DD")}`,
      filterStatus: "all",
      activeFilter: false,
      transProps: {
        name: "flip-list"
      },
      reservationStatus: "",
      paymentStatus: "",
      query: "",
      queryTemp: "",
      newBookingsCount: 0,
      rejectedBookingsCount: 0,
      upcomingBookingsCount: 0,
      sortBy: "create_at",
      sortDesc: "desc",
      sortOptions: [
        {
          value: "booking_number",
          text: "Reservation N°"
        },
        {
          value: "pickup_date",
          text: "Date & Time"
        },
        {
          value: "invoice",
          text: "Invoice N°"
        },
        {
          value: "passenger",
          text: "Passenger"
        },
        {
          value: "status",
          text: "Status"
        },
        {
          value: "payment",
          text: "Payment"
        },
        { value: "created_at", text: "Created At" }
      ],
      timeoutId: null,
      cardview: false,
      view: "table",
      fields: [],
      statsCardPrimary: {
        reservations: {
          label: "Amount Reservations",
          percent: "0",
          count: "0",
          condition: "up"
        },
        cancellations: {
          label: "Amount Cancellations ",
          percent: "0",
          count: "0",
          condition: "down"
        },
        pay: {
          label: "Total Payable",
          percent: "0",
          count: "$0.00USD",
          condition: "up"
        },
        sales: {
          label: "Total Sales",
          percent: "0",
          count: "$0.00USD",
          condition: "down"
        }
      },
      showReservationHistory: false,
      tempReservationId: "",
      tempBookingNumber: "",
      destinationFilter: "",
      destinationsOptions: [],
      localSupplierId: "",
      sortBySync: "",
      sortDescSync: false
    };
  },
  watch: {
    supplierId: {
      handler: async function(current, old) {
        if (!lodash.isEqual(current, old)) {
          this.localSupplierId = current;
          await this.initResevationData(this.supplierId);
        }
      },
      deep: true
    }
  },
  async created() {
    this.getSesion();
    this.fields = this.populateFiles(this.settings);
    this.localSupplierId = this.supplierId;
    await this.initResevationData(this.localSupplierId);
    this.destinationsOptions = await this.getDestinationsOptions();
  },
  methods: {
    canConfirmBooking,
    confirmBooking,
    canCancelBooking,
    canCompleteBooking,
    calculateHoursDifference,
    noShowBooking,
    canMarkBookingAsNoShow,
    canMarkBookingAsPaid,
    canResendBookingEmail,
    canDownloadQuote,
    canDownloadVoucher,
    duplicateBooking,
    deleteBooking,
    sendPaymentLink,
    resendNotifications,
    completeBooking,
    getLabelTransport,
    getTransportReference,
    async initResevationData(supplierId) {
      let { query, filters } = this.buildFilters(supplierId, this.filters.date);
      this.query = query;
      this.filters = filters;
      await this.getLimit();
      this.limit = this.paginationLimit;
      this.filterStatus = "all";
      this.currentPage = 1;
      this.get(true, this.limit, this.currentPage, this.query);
      this.getReservationsMetrics(this.filters);
      await this.getMetadata(this.query);
    },
    async filterByDate(date) {
      if (date) {
        this.filtersDate = date;
        this.filters.date = date;
        this.filterStatus = "all";
        this.activeFilter = true;
        this.query = this.addElementInQuery(this.query, "date", date);
        this.get(false, this.limit, this.currentPage, this.query);
        this.getReservationsMetrics(this.filters);
        await this.getMetadata(this.query);
      }
    },
    buildFilters(supplierId, date) {
      return {
        filters: {
          supplier: supplierId,
          date: date
        },
        query: new URLSearchParams({
          supplier: supplierId,
          date: date
        }).toString()
      };
    },
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value ? value.trim() : value);
      } else {
        searchParams.append(key, value ? value.trim() : value);
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    async filteredTab(value) {
      if (value === "all") {
        this.currentPage = 1;
        this.queryTemp = "";
        await this.get(true, this.limit, this.currentPage, this.query);
      } else if (value === "NW") {
        this.currentPage = 1;
        if (this.newBookingsCount > 0) {
          this.queryTemp = this.addElementInQuery(this.query, "status", value);
          await this.filterByReservationStatus(this.queryTemp);
        } else {
          this.reservations = [];
        }
      } else if (value === "SRB") {
        this.currentPage = 1;
        if (this.rejectedBookingsCount > 0) {
          this.queryTemp = this.addElementInQuery(this.query, "status", value);
          await this.filterByReservationStatus(this.queryTemp);
        } else {
          this.reservations = [];
        }
      } else {
        this.currentPage = 1;
        if (this.upcomingBookingsCount > 0) {
          this.queryTemp = this.addElementInQuery(this.query, "payment", value);
          await this.filterByStatusPayment(this.queryTemp);
        } else {
          this.reservations = [];
        }
      }
    },
    async filterByReservationStatus(query) {
      await this.get(true, this.limit, this.currentPage, query);
    },
    async filterByStatusPayment(query) {
      await this.get(true, this.limit, this.currentPage, query);
    },
    async applyFilterByReservationStatus(status) {
      this.filterStatus = "all";
      this.activeFilter = true;
      this.reservationStatus = status;
      this.query = this.addElementInQuery(this.query, "status", status);
      await this.filterByReservationStatus(this.query);
      await this.getMetadata(this.query);
    },
    async applyFilterByStatusPayment(status) {
      this.filterStatus = "all";
      this.activeFilter = true;
      this.paymentStatus = status;
      this.query = this.addElementInQuery(this.query, "payment", status);
      await this.filterByStatusPayment(this.query);
      await this.getMetadata(this.query);
    },
    async resetSearchFilter() {
      this.filters.date = `${moment()
        .startOf("month")
        .format("YYYY-MM-DD")} to ${moment()
        .endOf("month")
        .format("YYYY-MM-DD")}`;
      this.filtersDate = this.filters.date;
      let { query, filters } = this.buildFilters(
        this.supplierId,
        this.filters.date
      );
      this.query = query;
      this.filters = filters;
      this.filterStatus = "all";
      this.activeFilter = false;
      this.currentPage = 1;
      this.simpleSearch = "";
      this.paymentStatus = "";
      this.reservationStatus = "";
      await this.get(true, this.limit, this.currentPage, this.query);
      this.getReservationsMetrics(this.filters);
      await this.getMetadata(this.query);
    },
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        if (this.filterStatus === "all") {
          this.get(true, this.limit, this.currentPage, this.query);
        } else {
          this.get(true, this.limit, this.currentPage, this.queryTemp);
        }
      }
    },
    previousPaginations(page) {
      if (this.filterStatus === "all") {
        this.get(true, this.limit, page, this.query);
      } else {
        this.get(true, this.limit, page, this.queryTemp);
      }
    },
    nextPaginations(page) {
      if (this.filterStatus === "all") {
        this.get(true, this.limit, page, this.query);
      } else {
        this.get(true, this.limit, page, this.queryTemp);
      }
    },
    changePage(page) {
      if (this.filterStatus === "all") {
        this.get(true, this.limit, page, this.query);
      } else {
        this.get(true, this.limit, page, this.queryTemp);
      }
    },
    async download(reservations = []) {
      try {
        this.setLoad(true);
        let { data } = await ExportAPI.exportCSVReservations(
          this.queryTemp ? this.queryTemp : this.query,
          { reservations: reservations },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `reservations.csv`);
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    statusValue(status, metadata) {
      if (status === "NW") {
        return "status-new";
      } else if (status === "SC") {
        return "status-confirmed";
      } else if (status === "SCB" || status === "SBC") {
        return "status-cancelled";
      } else if (status === "SRB") {
        return "status-rejected";
      } else if (
        status === "DA" ||
        status === "DSR" ||
        status === "DAP" ||
        status === "POB"
      ) {
        return "status-started";
      } else if (status === "JF") {
        return "status-completed";
      } else if (status === "NS") {
        return "status-noshow";
      } else if (status === "BI") {
        return "status-draft";
      } else if (status === "PNDG") {
        if (metadata) {
          if (metadata.creator) {
            return isPartner(metadata.creator.type)
              ? "status-new-es"
              : "status-draft";
          } else {
            return "status-draft";
          }
        } else {
          return "status-draft";
        }
      } else {
        return {};
      }
    },
    showCircleInfo(oldStatus, currentstatus, createdAt, statusUpdate) {
      let diff = this.getDifference(createdAt) >= 48;
      if (currentstatus === "NW" && diff) {
        return true;
      } else {
        if (currentstatus === "SC" && oldStatus === "SC" && statusUpdate) {
          return true;
        } else if (
          currentstatus === "SC" &&
          oldStatus === "SC" &&
          !statusUpdate
        ) {
          return true;
        } else if (["SC", "NW"].indexOf(currentstatus) > -1 && statusUpdate) {
          return true;
        } else {
          return false;
        }
      }
    },
    addCircleInfo(oldStatus, currentstatus, createdAt, statusUpdate) {
      let diff = this.getDifference(createdAt) >= 48;
      if (currentstatus === "NW" && diff) {
        return "danger";
      } else {
        if (currentstatus === "SC" && oldStatus === "SC" && statusUpdate) {
          return "warning";
        } else if (
          currentstatus === "SC" &&
          oldStatus === "SC" &&
          !statusUpdate
        ) {
          return "info";
        } else if (["SC", "NW"].indexOf(currentstatus) > -1 && statusUpdate) {
          return "warning";
        } else {
          return "";
        }
      }
    },
    statusNew(oldStatus, currentstatus, createdAt, statusUpdate) {
      let diff = this.getDifference(createdAt) >= 48;
      if (currentstatus === "NW" && diff) {
        return "Pending Confirm";
      } else {
        if (currentstatus === "SC" && oldStatus === "SC" && statusUpdate) {
          return "Updated";
        } else if (
          currentstatus === "SC" &&
          oldStatus === "SC" &&
          !statusUpdate
        ) {
          return "Reconfirm";
        } else if (["SC", "NW"].indexOf(currentstatus) > -1 && statusUpdate) {
          return "Updated";
        } else {
          return "";
        }
      }
    },
    handleError(error, message, title = "Error!") {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: title,
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    async get(loader, limit, page, query) {
      await this.getReservations({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
    },
    refreshReservations() {
      this.get(
        false,
        this.limit,
        this.currentPage,
        this.queryTemp ? this.queryTemp : this.query
      );
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    getDifference(createdAt) {
      return moment(moment().format()).diff(
        moment(createdAt).format(),
        "hours",
        true
      );
    },
    async applySimpleSearch(value) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        this.activeFilter = true;
        if (value) {
          if (this.filterStatus === "all") {
            this.query = this.addElementInQuery(this.query, "search", value);
            await this.get(true, this.limit, this.currentPage, this.query);
            await this.getMetadata(this.query);
          } else {
            let query = this.addElementInQuery(this.queryTemp, "search", value);
            await this.get(true, this.limit, this.currentPage, query);
          }
        } else {
          this.query = this.deleteItemInQuery(this.query, ["search"]);
          await this.get(true, this.limit, this.currentPage, this.query);
          await this.getMetadata(this.query);
        }
      }, 500);
    },
    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    async getMetadata(query) {
      try {
        let { data } = await ReservationsAPI.getMetadataReservations(
          query,
          this.sesion.token
        );
        if (data) {
          this.newBookingsCount = data.newBookingsCount;
          this.rejectedBookingsCount = data.rejectedBookingsCount;
          this.upcomingBookingsCount = data.upcomingBookingsCount;
        }
      } catch (error) {
        this.newBookingsCount = 0;
        this.rejectedBookingsCount = 0;
        this.upcomingBookingsCount = 0;
      }
    },
    async applySortBy(value) {
      if (this.filterStatus === "all") {
        this.query = this.addElementInQuery(this.query, "sortBy", value);
        this.query = this.addElementInQuery(
          this.query,
          "sortType",
          this.sortDesc
        );
        await this.get(true, this.limit, this.currentPage, this.query);
      } else {
        this.queryTemp = this.addElementInQuery(
          this.queryTemp,
          "sortBy",
          value
        );
        this.queryTemp = this.addElementInQuery(
          this.queryTemp,
          "sortType",
          this.sortDesc
        );
        await this.get(true, this.limit, this.currentPage, this.queryTemp);
      }
    },
    async applySortType(value) {
      if (this.filterStatus === "all") {
        this.query = this.addElementInQuery(this.query, "sortType", value);
        await this.get(true, this.limit, this.currentPage, this.query);
      } else {
        this.queryTemp = this.addElementInQuery(
          this.queryTemp,
          "sortType",
          value
        );
        await this.get(true, this.limit, this.currentPage, this.queryTemp);
      }
    },
    getDirection: function(reservations = [], index) {
      if (reservations.length >= 5) {
        let position = reservations.length - index;
        if (position === 5) {
          return "down";
        } else {
          return position > 5 ? "down" : "up";
        }
      } else {
        return "down";
      }
    },
    getTableClass(reservations = []) {
      return reservations.length < 7 ? "b-table-separator" : "";
    },
    async changDraggable(column) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        this.fields
      );
      if (status) {
        this.setSettings(settings);
      }
    },
    closeTableGridModal(status) {
      this.modalManageColumn = status;
    },
    async updateSettingLayoutsByUserId(userId, fields = []) {
      try {
        let { data } = await SettingsAPI.updateSettingLayoutsByUserId(
          userId,
          { "settings.reservations.tableLayouts": fields },
          this.sesion.token
        );
        if (data.status) {
          return { status: true, settings: data.data.settings };
        } else {
          return { status: false, settings: null };
        }
      } catch (error) {
        return { status: false, settings: null };
      }
    },
    populateFiles(settings) {
      try {
        if (settings) {
          if (settings.reservations.tableLayouts.length > 0) {
            return settings.reservations.tableLayouts;
          }
        }
        return RESERVATION_TABLE_DEFAULTS.filter(option => {
          return option.settings.default;
        });
      } catch (error) {
        return RESERVATION_TABLE_DEFAULTS.filter(option => {
          return option.settings.default;
        });
      }
    },
    async getReservationsMetrics(payload) {
      try {
        let { data } = await OperatorsAPI.getReservationsMetrics(
          payload,
          this.sesion.token
        );
        if (data.status) {
          let { currentReservations, previousReservations } = data.data;
          this.initStatsCardPrimaryReservations(
            currentReservations,
            previousReservations
          );
          this.intiStatsCardPrimaryCancellations(
            currentReservations,
            previousReservations
          );
          this.intiStatsCardPrimaryPay(
            currentReservations,
            previousReservations
          );
          this.intiStatsCardPrimarySales(
            currentReservations,
            previousReservations
          );
        }
      } catch (error) {
        this.statsCardPrimary.reservations = {
          label: "Amount Reservations",
          percent: "0",
          count: "0",
          condition: "up"
        };
      }
    },
    getReservationsNumberMetrics(reservations = []) {
      return reservations.length;
    },
    getCancellationsMetrics(reservations = []) {
      return reservations.filter(reservation => {
        return reservation.status === "SBC" || reservation.status === "SCB";
      }).length;
    },
    getPayMetrics(reservations = []) {
      return reservations
        .filter(reservation => {
          return reservation.payment;
        })
        .map(reservation => reservation.pricing.totals.gross_price)
        .reduce((a, b) => a + b, 0);
    },
    getSalesMetrics(reservations = []) {
      return reservations
        .map(reservation => reservation.pricing.totals.gross_price)
        .reduce((a, b) => a + b, 0);
    },
    calculatePercentageDifference(currentValue, previousValue) {
      if (currentValue === 0 && previousValue === 0) {
        return 0;
      } else if (previousValue === 0) {
        return 0;
      } else {
        return ((currentValue - previousValue) / previousValue) * 100;
      }
    },
    initStatsCardPrimaryReservations(
      currentReservations = [],
      previousReservations = []
    ) {
      try {
        let currentReservationNumber = this.getReservationsNumberMetrics(
          currentReservations
        );
        let previousReservationNumber = this.getReservationsNumberMetrics(
          previousReservations
        );
        let percentageDifference = this.calculatePercentageDifference(
          currentReservationNumber,
          previousReservationNumber
        );
        this.statsCardPrimary.reservations = {
          label: "Amount Reservations",
          percent: Math.abs(percentageDifference).toFixed(2),
          count: `${currentReservationNumber}`,
          condition: `${percentageDifference >= 0 ? "up" : "down"}`
        };
      } catch (error) {
        this.statsCardPrimary.reservations = {
          label: "Amount Reservations",
          percent: "0",
          count: "0",
          condition: "up"
        };
        this.statsCardPrimary.pay = {
          label: "Total Payable",
          percent: "0",
          count: "0",
          condition: "up"
        };
        this.statsCardPrimary.sales = {
          label: "Total Sales",
          percent: "0",
          count: "0",
          condition: "up"
        };
        this.statsCardPrimary.cancellations = {
          label: "Amount Cancellations ",
          percent: "0",
          count: "0",
          condition: "up"
        };
      }
    },
    intiStatsCardPrimaryCancellations(
      currentReservations = [],
      previousReservations = []
    ) {
      try {
        let currentCancellations = this.getCancellationsMetrics(
          currentReservations
        );
        let previousCancellations = this.getCancellationsMetrics(
          previousReservations
        );

        let percentageDifference = this.calculatePercentageDifference(
          currentCancellations,
          previousCancellations
        );
        this.statsCardPrimary.cancellations = {
          label: "Amount Cancellations ",
          percent: Math.abs(percentageDifference).toFixed(2),
          count: `${currentCancellations}`,
          condition: `${percentageDifference >= 0 ? "up" : "down"}`
        };
      } catch (error) {
        this.statsCardPrimary.cancellations = {
          label: "Amount Cancellations ",
          percent: "0",
          count: "0",
          condition: "up"
        };
      }
    },
    intiStatsCardPrimaryPay(
      currentReservations = [],
      previousReservations = []
    ) {
      try {
        let currentPay = this.getPayMetrics(currentReservations);
        let previousPay = this.getPayMetrics(previousReservations);
        let percentageDifference = this.calculatePercentageDifference(
          currentPay,
          previousPay
        );
        this.statsCardPrimary.pay = {
          label: "Total Payable",
          percent: Math.abs(percentageDifference).toFixed(2),
          count: currentPay.toFixed(2),
          condition: `${percentageDifference >= 0 ? "up" : "down"}`
        };
      } catch (error) {
        this.statsCardPrimary.pay = {
          label: "Total Payable",
          percent: "0",
          count: "0",
          condition: "up"
        };
      }
    },
    intiStatsCardPrimarySales(
      currentReservations = [],
      previousReservations = []
    ) {
      try {
        let currentSales = this.getSalesMetrics(currentReservations);
        let previousSales = this.getSalesMetrics(previousReservations);
        let percentageDifference = this.calculatePercentageDifference(
          currentSales,
          previousSales
        );
        this.statsCardPrimary.sales = {
          label: "Total Sales",
          percent: Math.abs(percentageDifference).toFixed(2),
          count: currentSales.toFixed(2),
          condition: `${percentageDifference >= 0 ? "up" : "down"}`
        };
      } catch (error) {
        this.statsCardPrimary.sales = {
          label: "Total Sales",
          percent: "0",
          count: "0",
          condition: "up"
        };
      }
    },
    openReservationHistory(reservationId, bookingNumber) {
      this.tempReservationId = reservationId;
      this.tempBookingNumber = bookingNumber;
      this.showReservationHistory = true;
    },
    closeReservationHistoryModal() {
      this.showReservationHistory = false;
    },
    sortByCityName(destinations = []) {
      return destinations.sort((a, b) => {
        const firstCity = a.city.toUpperCase();
        const secondCity = b.city.toUpperCase();
        if (firstCity < secondCity) {
          return -1;
        }
        if (firstCity > secondCity) {
          return 1;
        }
        return 0;
      });
    },
    async getDestinationsOptions() {
      try {
        let { data } = await DestinationsAPI.getDestinationsOptions(
          this.sesion.token
        );
        if (data.status) {
          return this.sortByCityName(data.data);
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    selectDestination(destinationSlug) {
      if (destinationSlug) {
        let destination = this.branchesOptions.find(
          destination => destination.slug === destinationSlug
        );
        if (destination) {
          this.filters.branch = [];
        } else {
          this.filters.branch = [];
        }
      } else {
        this.filters.branch = [];
      }
    },

    getBookingType(type) {
      if (type === "airport") {
        return "Airport Transfer";
      } else if (type === "arrival") {
        return "Airport Transfer (Arrival)";
      } else if (type === "departure") {
        return "Airport Transfer (Departure)";
      } else if (type === "station") {
        return "Station Transfer";
      } else if (type === "port") {
        return "Port Transfer";
      } else if (type === "hourly") {
        return "Hourly";
      } else if (type === "journey") {
        return "Journey";
      }
    },
    getFormatDate(date, format) {
      return moment
        .parseZone(date)
        .utc(true)
        .format(format);
    },
    getFormatTime(time, format) {
      return moment(time, ["hh:mm A"]).format(format);
    },
    getPassenger(passengers = [], passengersCount) {
      if (!lodash.isEmpty(passengers)) {
        let [passenger] =
          passengers.filter(passenger => passenger.primary) || passengers;
        if (passenger) {
          return `${passenger.fullName} ${
            passengersCount ? "" : `+ ${passengersCount - 1}`
          }`;
        }
      }
      return "Unassigned";
    },
    getReservationStatusFormat(status) {
      if (status === "NW") {
        return "New";
      } else if (status === "SBC" || status === "SCB") {
        return "Cancelled";
      } else if (status === "SC") {
        return "Confirmed";
      } else if (status === "JF") {
        return "Completed";
      } else if (status === "SRB") {
        return "Rejected";
      } else if (status === "DA") {
        return "Driver Accepted";
      } else if (status === "DSR") {
        return "Driver Started Trip";
      } else if (status === "DAP") {
        return "Driver on Location";
      } else if (status === "POB") {
        return "POB";
      } else if (status === "NS") {
        return "No Show";
      } else if (status === "PNDG") {
        return "Pending";
      } else {
        return "Draft";
      }
    },
    convertTimeUnits(unit, value) {
      if (unit === "MINUTES") {
        return value / 60;
      } else if (unit === "DAYS") {
        return value * 24;
      } else {
        return value;
      }
    },
    getPaymentStatus(payment, paymentType, reservationStatus) {
      if (payment) {
        return true;
      } else {
        if (paymentType == "credit") {
          if (reservationStatus !== "PNDG") {
            return "true";
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
    getCommisionByPartner(partner, totalGrossPrice) {
      try {
        if (
          isPartner(partner.type) &&
          partner.type_charge === "commission"
        ) {
          let total = totalGrossPrice * (partner.commission / 100);
          return total.toFixed(2);
        } else {
          return "0.00";
        }
      } catch (error) {
        return "0.00";
      }
    },
    /**
     *
     * Booking Action Methods
     */
    async handlerCancelReservation(
      bookingId,
      pickupDate,
      timeZone,
      cancellationPolicy,
      callback
    ) {
      const utcNow = moment.tz(timeZone).utc(true);
      let refundEligibility = resolveRefundEligibility(
        utcNow,
        pickupDate,
        cancellationPolicy
      );
      await cancelBooking(bookingId, refundEligibility, callback);
    },
    async cancelReservationById(reservationId, reason, refundEligibility) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.canlcelReservationById(
          reservationId,
          reason,
          refundEligibility,
          this.sesion.token
        );
        this.setLoad(false);
        let canceled = data.data;
        if (!canceled) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation can't be Cancelled",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation can't be cancelled");
      }
    },
    async confirmReservationById(reservationId) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.confirmReservationById(
          reservationId,
          {},
          this.sesion.token
        );
        this.setLoad(false);
        if (data) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Reservation has been Confirmed",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Confirmed",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Confirmed");
      }
    },
    async updateBookingStatus(reservationId, status, reason = "") {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.changeRservationStatus(
          reservationId,
          status,
          reason,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          await this.get(
            true,
            this.limit,
            this.currentPage,
            this.queryTemp ? this.queryTemp : this.query
          );
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The reservation have been completed successfully",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The reservation could not be completed",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async resendEmailNotificationByBookingId(bookingId, recipients = []) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.resendEmailToUsersByReservationId(
          bookingId,
          recipients,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The notifications have been forwarded successfully",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The notifications couldn't be sent",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The operation couldn't be completed. Please try again"
        );
      }
    },
    async duplicateBookingById(bookingId, populate) {
      if (!populate) {
        return;
      }
      this.$router.push(`/reservations/new?recordId=${bookingId}`);
    },
    async downloadPDFType(bookingId, reference, isTransfer, pdfType, client) {
      try {
        let voucherType = isTransfer ? "product" : "transfer";
        this.setLoad(true);
        let { data } = await ReservationsAPI.downloadPDF(
          pdfType,
          bookingId,
          client,
          voucherType
        );
        this.setLoad(false);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${reference}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async deleteBookingById(bookingId) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.deleteReservation(
          bookingId,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data.status) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Deleted!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    ...mapActions(["getSesion", "getReservations", "getLimit"]),
    ...mapMutations(["setLoad", "setSigOut", "setSettings"])
  },
  destroyed() {
    clearTimeout(this.timeoutId);
  },
  computed: {
    reservations() {
      return mapReservationsForTable(this.responseReservations.docs || []);
    },
    ...mapGetters([
      "responseReservations",
      "sesion",
      "userRole",
      "load",
      "paginationLimit",
      "settings",
      "branchesOptions"
    ]),
    canUserDelete() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "DELETE");
    },
    canUserMarkBookingAsPaid() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "MARK_AS_PAID");
    },
    canUserCreate() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "CREATE");
    },
    canUserChangeStatus() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "CHANGE_STATUS");
    },
    today: function() {
      return moment().format("YYYY-MM-DD");
    },
    thisWeek: function() {
      return `${moment()
        .startOf("week")
        .format("YYYY-MM-DD")} to ${moment()
        .endOf("week")
        .format("YYYY-MM-DD")}`;
    },
    lastWeek: function() {
      return `${moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD")} to ${moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD")}`;
    },
    thisMonth: function() {
      return `${moment()
        .startOf("month")
        .format("YYYY-MM-DD")} to ${moment()
        .endOf("month")
        .format("YYYY-MM-DD")}`;
    },
    lastMonth: function() {
      return `${moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD")} to ${moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD")}`;
    },
    thisYear: function() {
      return `${moment()
        .startOf("year")
        .format("YYYY-MM-DD")} to ${moment()
        .endOf("year")
        .format("YYYY-MM-DD")}`;
    },
    formatD: function() {
      return "DD-MMM-YYYY";
    },
    formatT: function() {
      return "hh:mm A";
    }
  }
};
</script>
